import { render } from "./SettingHexagonIcon.vue?vue&type=template&id=6c57aa4e"
import script from "./SettingHexagonIcon.vue?vue&type=script&lang=js"
export * from "./SettingHexagonIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__